import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { CommonUtil } from './../util/common-util';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Constant } from './../constant';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  private apiPath = '/company';
  public companyCode: string;
  public companyName$;
  public isSurveyAnswerPage = false;
  /** ログイン・新規アカウント登録の画面か（SPでは組合名をヘッダーではなく画面の見出しの上に出す） */
  public isAuthEntryPage = false;
  /** SPのハンバーガーメニュー内の組合名の文字サイズ（px）。1行に収まらない長い組合名は小さくする */
  public spCompanyFontSize = 14;

  constructor(
    private router: Router,
    public auth: AuthService,
    private commonUtil: CommonUtil,
    private activatedRoute: ActivatedRoute,
  ) {
    //this.companyCode = this.activatedRoute.snapshot.params['code'];
    //this.companyCode = localStorage.getItem(Constant.lsCompanyCode);
    this.companyName$ = this.commonUtil.companyName$;
    // 画面を閉じたら購読をやめる
    this.commonUtil.companyName$.pipe(takeUntilDestroyed()).subscribe(name => {
      this.spCompanyFontSize = this.calcSpCompanyFontSize(name);
    });
  }

  /**
   * SPのハンバーガーメニュー内の組合名を1行に収める文字サイズ（px）を求める。
   * メニューの最大幅240pxから組合名の左右の余白（16px×2）を引いた208pxに収まらない場合だけ、14pxから縮小する
   */
  private calcSpCompanyFontSize(name: string): number {
    const baseSize = 14;
    const maxTextWidth = 240 - 16 * 2;
    if (!name) {
      return baseSize;
    }
    const context = document.createElement('canvas').getContext('2d');
    if (!context) {
      return baseSize;
    }
    context.font = `bold ${baseSize}px ${getComputedStyle(document.body).fontFamily}`;
    const width = context.measureText(name).width;
    if (width <= maxTextWidth) {
      return baseSize;
    }
    // 小数第1位で切り捨て（はみ出さない側に丸める）
    return Math.floor((baseSize * maxTextWidth / width) * 10) / 10;
  }

  ngOnInit() {
    this.updateCompanyCode();
    this.updateIsSurveyAnswerPage();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateCompanyCode();
        this.updateIsSurveyAnswerPage();
      });
  }

  private updateIsSurveyAnswerPage() {
    this.isSurveyAnswerPage = this.router.url.split('?')[0] === '/survey/answer';
    this.isAuthEntryPage = /^\/(login|signup)(\/|$|\?)/.test(this.router.url);
  }

  private extractCompanyCodeFromUrl(): string | null {
    const url = this.router.url; // 例: /login/abc

    const match = url.match(/\/(?:login|signup)\/([^\/\?]+)/);
    return match ? match[1] : null;
  }

  private updateCompanyCode() {
    const storedCompanyName = localStorage.getItem(Constant.lsCompanyName);
    const isLoggedIn = this.auth.loggedIn.value || !!storedCompanyName;

    if (isLoggedIn) {
      this.companyCode = localStorage.getItem(Constant.lsCompanyCode);
      if (storedCompanyName) {
        this.commonUtil.setCompanyName(storedCompanyName);
      } else if (this.companyCode) {
        this.getOrgName();
      }
      return;
    }

    const codeFromUrl = this.extractCompanyCodeFromUrl();
    const isAuthPage = /^\/(login|signup)(\/|$)/.test(this.router.url);

    if (codeFromUrl) {
      this.companyCode = codeFromUrl;
    } else if (!isAuthPage) {
      this.companyCode = localStorage.getItem(Constant.lsCompanyCode);
    } else {
      this.companyCode = null;
      this.commonUtil.setCompanyName('');
    }

    if (this.companyCode) {
      this.getOrgName();
    }
  }

  onLogout() {
    if (!this.commonUtil.checkOnline()) {
      return;
    }
    this.auth.signOut();
  }

   // ロゴ押下でダッシュボードに遷移
   onDashboard() {
    if (!this.auth.loggedIn || !this.commonUtil.checkOnline()) {
      return;
    }

    this.router.navigate(['/map']);
  }
  onOrganizationAccount() {
    if (!this.auth.loggedIn || !this.commonUtil.checkOnline()) {
      return;
    }

    this.router.navigate(['/account']);
  }

  onOrganizationAbout(){
    if (!this.auth.loggedIn || !this.commonUtil.checkOnline()) {
      return;
    }

    this.router.navigate(['/overview']);

  }
  onAccountAbout(){
    if (!this.auth.loggedIn || !this.commonUtil.checkOnline()) {
      return;
    }

    this.router.navigate(['/profile']);

  }
  onMasterSettings(){
    if (!this.auth.loggedIn || !this.commonUtil.checkOnline()) {
      return;
    }

    this.router.navigate(['/master']);

  }

  getOrgName() {
    const options = this.auth.createApiHeaderBeforeLogin();
    this.commonUtil
      .apiGet(this.apiPath + '/info/' + this.companyCode, options)
      .then(res => {
        if (res.status === Constant.OK) {
          //this.companyName = res.data.name;
          this.commonUtil.setCompanyName(res.data.name);
          console.log(this.commonUtil.companyName$)
        }
      })
      .catch(err => {
        this.commonUtil.debug().log(err);
      });
  }
}
